/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Feature } from './Feature';
import {
    FeatureFromJSON,
    FeatureFromJSONTyped,
    FeatureToJSON,
} from './Feature';

/**
 * Representation of a Classification
 * @export
 * @interface Classification
 */
export interface Classification {
    /**
     * Code of the classification
     * @type {string}
     * @memberof Classification
     */
    code?: string;
    /**
     * Name of the classification
     * @type {string}
     * @memberof Classification
     */
    name?: string;
    /**
     * List of features for given classification
     * @type {Array<Feature>}
     * @memberof Classification
     */
    features?: Array<Feature>;
}

/**
 * Check if a given object implements the Classification interface.
 */
export function instanceOfClassification(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClassificationFromJSON(json: any): Classification {
    return ClassificationFromJSONTyped(json, false);
}

export function ClassificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Classification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'features': !exists(json, 'features') ? undefined : ((json['features'] as Array<any>).map(FeatureFromJSON)),
    };
}

export function ClassificationToJSON(value?: Classification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'features': value.features === undefined ? undefined : ((value.features as Array<any>).map(FeatureToJSON)),
    };
}

